export default "__VITE_ASSET__6sYT01C9__"